import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { history, fetchWrapper } from '_helpers';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// create slice

const name = 'vocabularyquiz';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState,  extraReducers });

// exports

export const vocabularyquizActions = { ...slice.actions, ...extraActions };
export const vocabularyquizReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        // initialize state from local storage to enable user to stay logged in
        user: JSON.parse(localStorage.getItem('user')),
        error: null
    }
}


function createExtraActions() {
    const baseUrl = `https://api.webtracktechnologies.com.au:8002`;
    // const baseUrl = `http://localhost:8001`;
   //const registerUrl = `${process.env.REACT_APP_API_URL}/frontend/auth/register/step-1`;

    return {
        getVocabularyQuiz : getVocabularyQuiz()
    };    
    
    function getVocabularyQuiz() {
    return createAsyncThunk(
        `${name}/vocabularyquiz`,
        async (student, { rejectWithValue }) => {
            try {
                const response = await fetchWrapper.get(`${baseUrl}/quiz/all-vocab?student_id=${student}`);
                return response;
            } catch (error) {
                return rejectWithValue(error.message); // Handle errors
            }
        }
        );
       }

    // function getVocabularyQuiz() {
    //     return createAsyncThunk(
    //         `${name}/vocabularyquiz`,
    //         async (student) => {await fetchWrapper.get(`${baseUrl}/quiz/all-vocab?student_id=${student}`)}
            
    //         // async () => await fetchWrapper.get(`${baseUrl}/dictonary/vocabularylist`)
    //     );
    // }

    

}



function createExtraReducers() {
    return {
        ...getVocabularyQuiz()
    };

    function getVocabularyQuiz() {
        var { pending, fulfilled, rejected } = extraActions.getVocabularyQuiz;
        return {
            [pending]: (state) => {
                state.error = null;
            },
            [fulfilled]: (state, action) => {
                const vocabularyquiz = action.payload;
              //console.log(user,'get register user');  return false;
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                //localStorage.setItem('user', JSON.stringify(user));
                state.vocabularyquiz = vocabularyquiz;
                // toast.success('Check your email to verify the account..', {
                //     position: "top-right",
                //     autoClose: 5000,
                //     hideProgressBar: false,
                //     closeOnClick: true,
                //     pauseOnHover: true,
                //     draggable: true,
                //     progress: undefined,
                //     theme: "light",
                //     });
                // get return url from location state or default to home page
                // const { from } = { from: { pathname: '/verify-email' } };
                // history.navigate(from);
            },
            [rejected]: (state, action) => {
                // console.log(action.error,'get er');
                state.error = action.error;
                toast.error(action.error.message, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                    });
            }
        };
    }



}
